import * as React from "react";
import { Route, Redirect, Switch, withRouter, RouteComponentProps } from "react-router-dom";
import path, { RouteProps } from "./routes-path";
import Seznam from "./Seznam"

class AnketyHlasovani extends React.PureComponent<RouteComponentProps<RouteProps>, {}> {

    render() {
        return <Switch>
            <Route exact path={path} render={(routeProps) => <Seznam />} />
            <Redirect to={path} />
        </Switch>;

    }
}

export default withRouter(AnketyHlasovani);